"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var EVENT_MAPPING = (_a = {
        keypress: 1 /* KeyPress */,
        keydown: 0 /* KeyDown */,
        keyup: 2 /* KeyUp */,
        mousedown: 4 /* MouseDown */
    },
    _a[roosterjs_editor_dom_1.Browser.isIE ? 'textinput' : 'input'] = 12 /* Input */,
    _a);
/**
 * Map DOM events to editor plugin events
 * @param core The EditorCore object
 */
function mapPluginEvents(core) {
    return Object.keys(EVENT_MAPPING).map(function (pluginEvent) {
        return core.api.attachDomEvent(core, pluginEvent, EVENT_MAPPING[pluginEvent]);
    });
}
exports.default = mapPluginEvents;
//# sourceMappingURL=mapPluginEvents.js.map